export function sortItems(arr, sortOrder, sortKey) {
  return arr.sort(function (a, b) {
    var x = a[sortKey];
    var y = b[sortKey];
    if (typeof x === 'string') {
      x = x.toLowerCase();
    }
    if (typeof y === 'string') {
      y = y.toLowerCase();
    }
    if (sortOrder === 'desc') {
      // Sort in descending order
      if (x < y) {
        return 1;
      }
      if (x > y) {
        return -1;
      }
      return 0;
    } else {
      // Sort in ascending order by default
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    }
  });
}

//The following function sorts an array containing objects based on a numeric property
export const sortNumberFunc = (array, order, orderBy) =>
  array.sort((a, b) =>
    order === 'asc' ? a[orderBy] - b[orderBy] : b[orderBy] - a[orderBy]
  );

//The following function sorts an array cotaining objects based on a string property
export const sortStringFunc = (array, order, orderBy) => {
  return array.sort((a, b) =>
    order === 'asc'
      ? a[orderBy].localeCompare(b[orderBy])
      : b[orderBy].localeCompare(a[orderBy])
  );
};

//The following function sorts an array containing objects based on date property
export const sortDateFunc = (array, order, keyName) => {
  if (order === 'asc') {
    return array.sort(
      (a, b) => a[keyName] && new Date(a[keyName]) - new Date(b[keyName])
    ); //ascending order sort
  } else {
    return array.sort(
      (a, b) => b[keyName] && new Date(b[keyName]) - new Date(a[keyName])
    ); //descending order sort
  }
};



// WEBPACK FOOTER //
// ./src/utils/sortFunc.js